(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_auth", [], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_auth"] = factory();
	else
		root["aws_amplify_auth"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition